import { useState, useMemo } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react'
import {
  useGetSingleProjectByUserAdmin,
  useUpdateSingleProjectByUserAdmin,
} from 'lib/react-query/queriesProject'

const useSelectedUsers = inputValue => {
  const [userSelected, setSelectedUsers] = useState([])

  const { idProject } = useParams()
  const { user } = useAuth0()
  const { mutateAsync } = useUpdateSingleProjectByUserAdmin(user.sub, idProject)
  const queryClient = useQueryClient()
  const { data: users } = queryClient.getQueryData(['users-auth0']) || {}
  const { data: usersProject } = useGetSingleProjectByUserAdmin(
    user.sub,
    idProject
  ) || {}

  const filterUsers = useMemo(() => {
    if (!users || !usersProject) return { availableUsers: [], assignedUsers: [] }

    const { data: currentProject } = usersProject
    const allUsersProject = [...(currentProject?.user || []), ...(currentProject?.users || [])]

    // Usuarios asignados al proyecto
    const assignedUsers = users.filter(user =>
      allUsersProject.some(userProject => userProject === user.user_id)
    ).filter(user =>
      inputValue.length >= 3 &&
      (user.name.toLowerCase().includes(inputValue.toLowerCase()) ||
       user.email.toLowerCase().includes(inputValue.toLowerCase()))
    )

    // Usuarios no asignados al proyecto
    const userNotAlreadyAssignedToProject = users.filter(
      user => !allUsersProject.some(userProject => userProject === user.user_id)
    )

    // Usuarios disponibles (no asignados y no seleccionados)
    const availableUsers = inputValue.length >= 3
      ? userNotAlreadyAssignedToProject.filter(
          user =>
            !userSelected.some(
              selectedUser => selectedUser.user_id === user.user_id
            ) &&
            (user.name.toLowerCase().includes(inputValue.toLowerCase()) ||
             user.email.toLowerCase().includes(inputValue.toLowerCase()))
        )
      : userNotAlreadyAssignedToProject.filter(
          user =>
            !userSelected.some(
              selectedUser => selectedUser.user_id === user.user_id
            )
        )


    return { availableUsers, assignedUsers }
  }, [users, usersProject, userSelected, inputValue])

  const addUser = user => {
    setSelectedUsers(prevState => [...prevState, { ...user, rol: 'Usuario' }])
  }

  const handleDeleteUser = user => {
    setSelectedUsers(prevState =>
      prevState.filter(selectedUser => selectedUser.user_id !== user.user_id)
    )
  }

  const handleUpdateUser = (user, newValue) => {
    setSelectedUsers(prevState =>
      prevState.map(selectedUser =>
        selectedUser.user_id === user.user_id
          ? { ...selectedUser, ...newValue }
          : selectedUser
      )
    )
  }

  const handleAddUsersToProject = async () => {
    const { data: currentProject } = usersProject || {}

    let usuarios = [...(currentProject?.users || [])]
    let administradores = [...(currentProject?.user || [])]

    const usersToAdd = userSelected
      .filter(user => user.rol === 'Usuario')
      .map(user => user.user_id)
    const usersToAddAdmin = userSelected
      .filter(user => user.rol === 'Administrador')
      .map(user => user.user_id)

    usuarios = [...usuarios, ...usersToAdd]
    administradores = [...administradores, ...usersToAddAdmin]

    await mutateAsync({ body: { user: administradores, users: usuarios } })

    // Invalida la query para actualizar usersProject
    queryClient.invalidateQueries(['singleProject', user.sub, idProject])

    // Reiniciar userSelected
    setSelectedUsers([])
  }

  return {
    userSelected,
    addUser,
    handleDeleteUser,
    handleUpdateUser,
    handleAddUsersToProject,
    users: filterUsers.availableUsers,
    assignedUsers: filterUsers.assignedUsers,
  }
}

export default useSelectedUsers